module.exports = __webpack_public_path__ + "img/coins.504cadff.jpg";